import { AuthenticationTokenInterface } from '../token.interface';
import { BrowserStorageInterface } from '../../browser/storage.interface';
import { uuidGenerate } from '../../../helper/uuid/generate';

export class AuthenticationTokenUuid implements AuthenticationTokenInterface {
  public static TOKEN_KEY: string = 'pf-authentication-token-uuid';

  public token: string | null;

  /**
   *
   * @param browserStorageService
   */
  constructor(private browserStorageService: BrowserStorageInterface) {}

  /**
   * Returns user authentication token
   */
  public getToken(): string {
    // Token in memory
    if (this.token) {
      return this.token;
    }

    // Get token from browser storage
    this.token = <string | null>this.browserStorageService.getData(AuthenticationTokenUuid.TOKEN_KEY);

    // No token in browser storage
    if (!this.token) {
      // Generate a new token and keep it in memory
      this.token = uuidGenerate();

      // Keep token in browser storage
      this.browserStorageService.setData(AuthenticationTokenUuid.TOKEN_KEY, this.token);
    }

    return this.token;
  }
}
